/** @type {Record<import("@liquidweb-dev/club-sauce/types/billingCycle").BillingCycleT, string>} */
const cyclesToTimeUnit = {
	monthly: 'mo',
	quarterly: '3 months',
	biannually: '6 months',
	yearly: 'yr',
	biennially: '2 yrs',
	triennially: '3 yrs',
};

export default cyclesToTimeUnit;
